var map = {
	"./google-laurel-da-DK.svg": 67502,
	"./google-laurel-de-DE.svg": 49292,
	"./google-laurel-en-GB.svg": 13462,
	"./google-laurel-en-US.svg": 30189,
	"./google-laurel-es-ES.svg": 23894,
	"./google-laurel-es-MX.svg": 96405,
	"./google-laurel-fr-FR.svg": 79222,
	"./google-laurel-it-IT.svg": 83188,
	"./google-laurel-nb-NO.svg": 29323,
	"./google-laurel-nl-NL.svg": 77042,
	"./google-laurel-pl-PL.svg": 73610,
	"./google-laurel-pt-BR.svg": 5558,
	"./google-laurel-pt-PT.svg": 24234,
	"./google-laurel-sv-SE.svg": 4631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;